import { LoadingButton } from "@mui/lab";
import BsModal from "..";
import { DeleteModalIcon } from "../../../../../assets/common-svg/CommonSvg";
import { Box, Typography } from "@mui/material";

const DeleteModal = ({ open, setClose,handleRejection, handleSuccess, title, buttonText, rejectButtonText,otherIcon, btnPrimary, fontWeight }) => {
    return <BsModal open={open} onClose={() => setClose(false)}>
        <Box className="text-center h-full flex flex-col gap-8 pl-3 pr-3">
            <div className="self-center">
                {otherIcon ? otherIcon : <DeleteModalIcon />}
            </div>
            <Typography
                align="center"
                id="spring-modal-title"
                variant="h5"
                fontWeight={fontWeight?? 700}
                component="h5"
            >
                {title}
            </Typography>
        </Box>
        <Box className="flex justify-between gap-2 mt-4"> {/* @info added justify-between to align buttons*/}
            <LoadingButton
                onClick={() =>handleRejection?handleRejection(): setClose(false)}
                className="w-[160px] h-[40px] bg-[#DDDDDD] text-[#828282] hover:!bg-[#DDDDDD] transition transform hover:-translate-y-1 hover:shadow-lg"
            >
              {rejectButtonText? rejectButtonText: 'Close'}
            </LoadingButton>
            <LoadingButton
                className={`transition transform hover:-translate-y-1 hover:shadow-lg ${btnPrimary ? `bg-${btnPrimary} hover:bg-${btnPrimary}` : 'bg-[#FD5456] hover:bg-[#FD5456]'}`}
                onClick={() => handleSuccess()}
            >
                {buttonText}
            </LoadingButton>
        </Box>
    </BsModal>
}
export default DeleteModal;